var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8496 26.5959C50.8161 26.5959 51.5996 27.3794 51.5996 28.3459V49.346C51.5996 50.3124 50.8161 51.096 49.8496 51.096H7.84961C6.88311 51.096 6.09961 50.3124 6.09961 49.346V28.3556C6.09961 27.3891 6.88311 26.6056 7.84961 26.6056C8.81611 26.6056 9.59961 27.3891 9.59961 28.3556V47.596H48.0996V28.3459C48.0996 27.3794 48.8831 26.5959 49.8496 26.5959Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6122 6.10851C28.2956 5.42509 29.4036 5.42509 30.087 6.10851L40.587 16.6085C41.2705 17.2919 41.2705 18.4 40.587 19.0834C39.9036 19.7668 38.7956 19.7668 38.1122 19.0834L28.8496 9.82082L19.587 19.0834C18.9036 19.7668 17.7956 19.7668 17.1122 19.0834C16.4288 18.4 16.4288 17.2919 17.1122 16.6085L27.6122 6.10851Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8399 5.59595C29.8064 5.59595 30.5899 6.37945 30.5899 7.34595V37.6793C30.5899 38.6458 29.8064 39.4293 28.8399 39.4293C27.8734 39.4293 27.0899 38.6458 27.0899 37.6793V7.34595C27.0899 6.37945 27.8734 5.59595 28.8399 5.59595Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.70e08344.svg";
export { ForwardRef as ReactComponent };